/**
 * 微信js-sdk
 * 参考文档：https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421141115
 */
import wx from 'weixin-js-sdk'
import apis from "@/api";
const wxApi = {
    /**
     * [wxRegister 微信Api初始化]
     * @param option
     */
    wxRegister(option) { //data是微信配置信息，option是分享的配置内容

        let url = window.location.href;
        apis.getJSSDK({type: 1, url: url}).then(res => {
            return res.data
        }).then(data => {
            wx.config(data.data)

            wx.ready(() => {
                wx.updateTimelineShareData({
                    title: option.title, // 分享标题
                    link: option.link, // 分享链接
                    imgUrl: option.imgUrl, // 分享图标
                    desc: option.desc, // 分享描述
                    success() {
                        // 用户成功分享后执行的回调函数
                        option.success()
                    },
                    cancel() {
                        // 用户取消分享后执行的回调函数
                        option.error()
                    }
                });
                wx.updateAppMessageShareData({
                    title: option.title, // 分享标题
                    desc: option.desc, // 分享描述
                    link: option.link, // 分享链接
                    imgUrl: option.imgUrl, // 分享图标
                    success() {
                        // 用户成功分享后执行的回调函数
                        option.success()
                    },
                    cancel() {
                        // 用户取消分享后执行的回调函数
                        option.error()
                    }
                })
            })
        });
    }
}
export default wxApi